import "../../assets/styles/tailwind.css";

import "bootstrap/dist/css/bootstrap-theme.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../layout/datatables.min.css";
import "font-awesome/css/font-awesome.min.css";
import "../layout/typeahead.css";

import "../../assets/styles/styles.scss";
import "../../assets/styles/sample.scss";
import "../../assets/styles/custom.scss";
import "../../assets/styles/shared.scss";

import "../../app/layout/styles.css";
import "../../app/layout/listing.css";
import "../../assets/styles/bootstrap-colorselector.min.css";

import "../../assets/styles/components/_saveOffice.scss";
import "../../assets/styles/components/_settings.scss";
import "../../assets/styles/components/_usersPage.scss";
import "../../assets/styles/components/_dashboardPage.scss";
import "../../assets/styles/components/_contactPage.scss";
import "../../assets/styles/components/_saveProperty.scss";
import "../../assets/styles/components/_auditTrailPage.scss";
import "../../assets/styles/components/_saveCountry.scss";
import "../../assets/styles/components/_customizePage.scss";
import "../../assets/styles/components/_saveGroup.scss";
import "../../assets/styles/components/_integrationsPage.scss";
import "../../assets/styles/components/_property.scss";
import "../../assets/styles/components/_saveUser.scss";
import "../../assets/styles/components/_saveReport.scss";
import "../../assets/styles/components/_saveBrochurePage.scss";
import "../../assets/styles/components/_omsToBase.scss";
import "../../assets/styles/components/_mapAreaTool.scss";
import "../../assets/styles/components/_clearCache.scss";
import "../../assets/styles/components/_saveContact.scss";
import "../../assets/styles/components/_contactPage.scss";
import "../../assets/styles/components/_saveContentPage.scss";
import "../../assets/styles/components/_libraryPage.scss";
import "../../assets/styles/components/_login.scss";
import "../../assets/styles/components/_officesPage.scss";
import "../../assets/styles/components/_saveImportPropertyPage.scss";
import "../../assets/styles/components/_saveIntegration.scss";
import "../../assets/styles/components/_listingReports.scss";
import "../../assets/styles/components/_saveDeal.scss";
import "../../assets/styles/components/commonComponents/_autosuggestInput.scss";

import "jquery";
import "bootstrap/dist/js/bootstrap.min.js";

import "bootbox";
import "datatables.net-bs/js/dataTables.bootstrap.min.js";
import "../../js/custom.js";
import "../../js/bootstrap-colorselector.min.js";

import "datatables.net-responsive";
import "tippy.js/dist/tippy.css";

import { observer } from "mobx-react";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { useStore } from "../stores/store";
import { ThemeColorsModel } from "../models/ThemeColorsModel";
import AjaxLoader from "../common/common-components/AjaxLoader";
import { Router } from "./Router";

function App() {
  const { commonStore, userStore, masterDataStore } = useStore();

  const setThemeColors = (themeColors: ThemeColorsModel) => {
    document.documentElement.style.setProperty(`--color1`, themeColors.color1);
    document.documentElement.style.setProperty(`--color2`, themeColors.color2);
    document.documentElement.style.setProperty(`--color3`, themeColors.color3);
    document.documentElement.style.setProperty(`--color4`, themeColors.color4);
    document.documentElement.style.setProperty(`--color5`, themeColors.color5);
    document.documentElement.style.setProperty(`--color6`, themeColors.color6);
    document.documentElement.style.setProperty(`--color7`, themeColors.color7);
    document.documentElement.style.setProperty(
      `--color1tint`,
      themeColors.color1Tint
    );
    document.documentElement.style.setProperty(
      `--color2tint`,
      themeColors.color2Tint
    );
    document.documentElement.style.setProperty(
      `--color6tint`,
      themeColors.color6Tint
    );
  };

  useEffect(() => {
    if (commonStore.token) {
      userStore.getUserSession().finally(() => {
        commonStore.setAppLoaded();
      });
      masterDataStore.loadMasterData();
    } else {
      commonStore.setAppLoaded();
    }
  }, [commonStore, userStore, masterDataStore]);

  if (!commonStore.appLoaded) return <AjaxLoader />;

  const userSession = userStore.userSession;

  if (userSession !== null) {
    setThemeColors(userSession.themeColors);
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        theme="colored"
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
        className="toast-container-custom"
        toastClassName="toast-custom"
        containerId="toast-root-container"
        newestOnTop={true}
        autoClose={5000}
      />
      <Router />
    </>
  );
}

export default observer(App);
